import { isFunction, isObjectLike } from "lodash"

export function isPromise<T = any>(val: any): val is Promise<T> {
  return isObjectLike(val) && isFunction((val as Promise<T>).then) && isFunction(val.catch)
}

export function fulfillPromise(promise: PromiseLike<any>) {
  if (isPromise(promise)) {
    promise?.then(
      () => {},
      () => {},
    )
  }
}
